"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.bulkActionDialogFactory = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const lodash_1 = require("lodash");
const Grid_1 = __importDefault(require("@material-ui/core/Grid"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const dialog_1 = require("../../../components/dialog/dialog");
const form_1 = require("../../form/form");
const form_custom_field_1 = require("../../form/fields/form-custom-field");
const bulk_action_dialog_hook_1 = require("./bulk-action-dialog-hook");
const bulk_action_dialog_styles_1 = require("./bulk-action-dialog-styles");
const bulk_action_dialog_api_1 = require("./bulk-action-dialog-api");
function bulkActionDialogFactory({ url, paramsMapper, title, Fields, apiCall = bulk_action_dialog_api_1.bulkActionDialogApi, }) {
    return react_1.forwardRef(function BulkActionDialogWithoutRef(_, ref) {
        const { submitting, dialogRef, formRef, applyToSelected, count, confirm, } = bulk_action_dialog_hook_1.useBulkActionDialog({
            url,
            paramsMapper,
            ref,
            apiCall,
        });
        const classes = bulk_action_dialog_styles_1.useStyles();
        const intl = react_intl_1.useIntl();
        return (react_1.default.createElement(dialog_1.Dialog, { title: title, confirmLabel: intl.formatMessage({
                id: 'EAS_TABLE_BULK_DIALOG_BTN_CONFIRM',
                defaultMessage: 'Vykonat',
            }), onConfirm: confirm, ref: dialogRef }, () => (react_1.default.createElement(Grid_1.default, { container: true },
            react_1.default.createElement("div", { style: { width: 400 } },
                react_1.default.createElement(form_1.Form, { initialValues: {}, onSubmit: lodash_1.noop, ref: formRef, editing: true },
                    react_1.default.createElement(form_custom_field_1.FormCustomField, { labelOptions: { hide: true }, layoutOptions: { noUnderline: true } },
                        react_1.default.createElement(Typography_1.default, { variant: "body1", classes: { root: classes.warning } },
                            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_TABLE_BULK_DIALOG_WARNING", defaultMessage: `Akce bude aplikována na {count, plural, 
                      one {1 {applyToSelected, select, 
                          true {VYBRANOU}
                          false {VYFILTROVANOU}
                        } položku}
                      few {# {applyToSelected, select, 
                          true {VYBRANÉ}
                          false {VYFILTROVANÉ}
                        } položky}
                      other {# {applyToSelected, select, 
                          true {VYBRANÝCH}
                          false {VYFILTROVANÝCH}
                        } položek}
                      }.`, values: { count, applyToSelected } }))),
                    react_1.default.createElement(Fields, { disabled: submitting })))))));
    });
}
exports.bulkActionDialogFactory = bulkActionDialogFactory;
//# sourceMappingURL=bulk-action-dialog.js.map